import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";
import { ProcessServersTable } from "features/processServersTable";

function ProcessServersPage() {
  return (
    <PageLayout>
      <Content>
        <ProcessServersTable />
      </Content>
    </PageLayout>
  );
}

export default ProcessServersPage;
